// @ts-check

/**
 * Product gallery Web Component.
 * - Thumbnail click syncs main image
 * - Touch swipe on mobile
 * - Active thumbnail state
 */
(() => {
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      /** @type {NodeListOf<HTMLButtonElement>} */
      this.thumbnails = this.querySelectorAll('.product-gallery__thumbnail');
      /** @type {NodeListOf<HTMLElement>} */
      this.slides = this.querySelectorAll('.product-gallery__slide');
      /** @type {HTMLElement | null} */
      this.mainGallery = this.querySelector('.product-gallery__main');

      /** @type {number} */
      this.currentIndex = 0;

      // Thumbnail click
      this.thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goToSlide(index));
      });

      // Touch swipe on mobile
      if (this.mainGallery) {
        this._setupSwipe();
      }
    }

    /**
     * Navigate to a specific slide
     * @param {number} index
     */
    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;

      // Update slides
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('product-gallery__slide--active', i === index);
      });

      // Update thumbnails
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('product-gallery__thumbnail--active', i === index);
      });

      this.currentIndex = index;
    }

    _setupSwipe() {
      if (!this.mainGallery) return;

      let startX = 0;
      let endX = 0;

      this.mainGallery.addEventListener(
        'touchstart',
        (/** @type {TouchEvent} */ e) => {
          startX = e.touches[0].clientX;
        },
        { passive: true }
      );

      this.mainGallery.addEventListener(
        'touchmove',
        (/** @type {TouchEvent} */ e) => {
          endX = e.touches[0].clientX;
        },
        { passive: true }
      );

      this.mainGallery.addEventListener('touchend', () => {
        const threshold = 50;
        const diff = startX - endX;

        if (Math.abs(diff) < threshold) return;

        if (diff > 0) {
          // Swipe left - next
          this.goToSlide(this.currentIndex + 1);
        } else {
          // Swipe right - previous
          this.goToSlide(this.currentIndex - 1);
        }
      });
    }
  }

  customElements.define('product-gallery', ProductGallery);
})();
